import { inject, observer } from 'mobx-react';
import { ReactComponent as CloseIcon } from "../../svg/close.svg";
import { ReactComponent as CheckIcon } from '../../svg/check-circle.svg'
import React from 'react'
import ModalWrapper from './ModalWrapper';
import Loader from '../Buttons/Loader';

@inject('workAreaStore', 'store', 'errorStore') @observer
class NFTModal extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      name: '',
      description: '',
      supply: 1
    }
  }

  componentDidMount(){
    const { title } = this.props.workAreaStore
    this.setState({
      name: title
    })
    this.fetchImage()
  }

  fetchImage(){
    if(!this.props.nftPreview){
      this.props.store.fetchNFTImage()
    }
  }

  setNFTImageLoaded(){
    this.props.store.setNFTLoading(false)
  }

  showLoadError(){
    this.props.errorStore.setErrorMessage(`Failed to create NFT image, try again`, true)
  }

  closeModal(){
    this.props.store.toggleAnyModal(null, false)
  }

  handleChange(e){
    const { name, value } = e.target
    this.setState({
      [name]: value
    })
  }

  handleSupplyChange(e, isForm = false){
    let baseVal = Math.floor(e.target.value)
    const valStr = String(e.target.value).split('')
    if(valStr.length >= 2 && valStr[0] === '0'){
      let sliceIdx = 0
      if(valStr[0] === '-'){
        sliceIdx = 1
      }
      valStr.splice(sliceIdx, 1)
      baseVal = Number(valStr.join(''))
    }
    const val = Number(baseVal)
    if(isForm){
      const input = document.querySelector('.nft-modal__body .form-control.supply-amount')
      if(input){
        input.setAttribute('value', String(baseVal))
        input.value = String(baseVal)
      }
    }
    this.setState({
      supply: val
    })
  }

  mintNFT(){
    const { name, description, supply } = this.state
    const sup = Number(supply)
    if(sup < 1 || sup > 1000){
      this.props.errorStore.setErrorMessage(`Supply cannot be less than 1 or greater than 1000`, true)
      return
    }
    if(!this.props.store.nftPreview || this.props.store.nftPreviewLoading){
      this.props.errorStore.setErrorMessage(`Please wait for the image to be generated`, true)
      return 
    }
    if(!name || !name.length){
      this.props.errorStore.setErrorMessage(`Make sure your NFT has a name`, true)
    }else{
      this.props.store.mintNFT(name, description, sup)
    }
  }

  render(){
    const { nftPreview, nftPreviewLoading, nft, nftMintLoading, nftMinted } = this.props.store
    const { width, height } = this.props.workAreaStore.pages[0]
    return (
      <ModalWrapper
        modalClass='nft-modal'
        close={this.closeModal.bind(this)}
      >
        <div className='nft-modal__wrapper row no-gutters'>
          <div className='col-sm-12 col-md-6 nft-modal__text'>
            <div className='nft-modal__body w-100'>
              <div className='form-group'>
                <label>
                  NFT Name
                </label>
                <input
                  type='text'
                  placeholder='The name of your NFT'
                  value={this.state.name}
                  name='name'
                  className='form-control'
                  onChange={e => this.handleChange(e)}
                />
              </div>
              <div className='form-group'>
                <label style={{marginBottom: '2.5px'}}>
                  Supply
                </label>
                <label className='gray small'>
                  Set the amount of NFTs you want to create
                </label>
                <div className='input-flex-row'>
                  <input
                    className='slider'
                    type='range'
                    min='1'
                    max='1000'
                    value={this.state.supply}
                    onChange={e => this.handleSupplyChange(e)}
                    style={{
                      backgroundSize: (Number(this.state.supply) - 1) * 100 / (1000 - 1) + '% 100%'
                    }}
                  />
                  <input
                    type='number'
                    className='form-control supply-amount'
                    min={1}
                    max={1000}
                    value={this.state.supply}
                    onChange={e => this.handleSupplyChange(e, true)}
                  />
                </div>
              </div>
              <div className='form-group'>
                <label>
                  NFT Description <span className='gray'>Optional</span>
                </label>
                <textarea
                  type='text'
                  placeholder='Description for your NFT'
                  value={this.state.description}
                  name='description'
                  className='form-control'
                  onChange={e => this.handleChange(e)}
                />
              </div>
              <div className='nft-modal__body__meta'>
                <span className='wallet-meta'>
                  Wallet address: {'\n'}
                  <a href={`https://polygonscan.com/address/${nft.wallet_address}`} target='_blank'>{nft.wallet_address.slice(0, 5)}...{nft.wallet_address.slice(nft.wallet_address.length - 5)}</a>
                </span>
              </div>
            </div>
            <div className='nft-modal__buttons w-100'>
              {
                nftMintLoading ? (
                  <div className='nft-modal__buttons__loading-wrapper'>
                    <Loader className='saving-loader small' />
                  </div>
                )
                :
                (
                  nftMinted ? (
                    <div className='nft-modal__buttons__uploaded'>
                      <CheckIcon />
                      <span>
                        NFT Minted
                      </span>
                      <span className='link'>
                        Your NFT will appear {' '}
                        <a href='https://opensea.io/account?tab=private' target="_blank">
                        here
                        </a>
                        {' '} in a few minutes
                      </span>
                    </div>
                  )
                  :
                  (
                  <button 
                    className='btn btn-primary'
                    onClick={() => this.mintNFT()}
                  >
                    Mint on OpenSea
                  </button>
                  )
                )
              }
            </div>
          </div>
          <div className='col-xs-0 col-md-6 nft-modal__image-wrapper'>
            {
              <div 
                className='nft-modal__custom-wrapper'
                style={{
                  width: '100%',
                  minHeight: '400px'
                }}
              >
                {
                  nftPreview && !nftPreviewLoading ? (
                    <img 
                      className={`nft-modal__custom-image${height > width ? ' high' : ''}`} 
                      src={nftPreview} 
                      onLoad={e => this.setNFTImageLoaded()}
                      onError={e => this.showLoadError()}
                    />
                  )
                  :
                  (
                    <div className='nft-modal__image-loader'>
                      <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader'/>
                    </div>
                  )
                }
              </div>
            }
            <CloseIcon className='close-icon cursor-pointer' onClick={this.closeModal.bind(this)} />
          </div>
      </div>
      </ModalWrapper>
    )
  }

}

export default NFTModal